import { z } from "zod";
import { GOAL_CATEGORIES } from "@/lib/services/goal-service";

/**
 * The conversion-goal dialog.
 *
 * The key rule mirrors the service's. It used to live inside the save handler
 * as a regex test that fired a toast, which meant the message named the
 * pattern rather than the field, and only after the user had pressed Create.
 */
export const GOAL_KEY_RE = /^[a-z][a-z0-9_]{0,31}$/;

export const goalFormSchema = z.object({
  key: z
    .string()
    .trim()
    .regex(GOAL_KEY_RE, "Начните с буквы; только строчные латинские буквы, цифры и _ (до 32)"),
  displayName: z.string(),
  category: z.string(),
  countsAsRevenue: z.boolean(),
  isPrimary: z.boolean(),
  allowMultiple: z.boolean(),
  sortOrder: z.number(),
});

export type GoalFormValues = z.infer<typeof goalFormSchema>;

export { GOAL_CATEGORIES };
